<template>
    <el-form  ref="form" :model="form_obj" :rules="rules" label-width="180px" size="small">
        <el-form-item label="客户名称"  prop="name" class="demo-dynamic">
            <el-input v-model.trim="form_obj.name" v-if="this.$route.path != '/customers/create'&&this.$route.path != '/customers/update'||this.$route.query['public']" disabled></el-input>
            <el-input v-model.trim="form_obj.name"  v-if="this.$route.path == '/customers/create'||this.$route.path == '/customers/update'&&!this.$route.query['public']"  @input="querySearchAsync($event)" :disabled="$route.path == '/customers/update'"></el-input>
          <el-card v-if="kehu_names.length > 0" class="box-card"  >
            <div style="height: 300px;overflow:auto"  @click="noShow" >
              <div slot="header" class="clearfix">
                <span>已存在下列相似名称</span>
              </div>
              <div v-for="item in kehu_names"  class="text item">
                {{item.name }}({{item.province_name}}{{item.city_name}}{{item.district_name}})
              </div>
            </div>
          </el-card>
<!--            <el-input v-model.trim="form_obj.name"  v-if="this.$route.path == '/customers/create'||this.$route.path == '/customers/update'&&!this.$route.query['public']"></el-input>-->
        </el-form-item>

        <el-form-item label="别名简称">
            <el-input v-model="form_obj.show_name" style="width:90%"></el-input>
            <el-tooltip placement="right">
                <div slot="content">
                    显示名称|简称 用于提供给其他产品（校本3，数字化校园）展示的简称,<br/>原来的简称字段是支持多个没法具体选择哪个就衍生出这个字段<br/>
                </div>
                <i class="el-icon-info"></i>
            </el-tooltip>
        </el-form-item>

        <!-- <el-form-item label="学段选择" prop="stages"> -->
        <el-form-item label="学段选择" prop="stages">
            <el-checkbox-group v-model="form_obj.stages" class="product-use" :disabled="$route.path == '/customers/update'">
                <el-checkbox label="1" >小学</el-checkbox>
                <el-checkbox label="2" >初中</el-checkbox>
                <el-checkbox label="3" >高中</el-checkbox>
                <el-checkbox label="4" >中职</el-checkbox>
            </el-checkbox-group>
        </el-form-item>

        <DistrictLinkage
                v-if="this.$route.path == '/customers/create' || Acs('/customers/index')"
                :provinceId="form_obj.province_id"
                :cityId="form_obj.city_id"
                :districtId="form_obj.district_id"
                @change="handleChange($event)" 
                :isDisabled="$route.path == '/customers/update'">
        </DistrictLinkage>

        <el-form-item  label="客户来源" prop="origin">
            <el-select v-if="sources" v-model="form_obj.origin" placeholder="请选择" style="width:100%">
                <el-option v-for="(item, key) in sources" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="客户类型" prop="type">
            <el-select v-if="types" v-model="form_obj.type" placeholder="请选择" style="width:100%" :disabled="$route.path == '/customers/update'">
                <el-option v-for="(item, key) in types" :key="item" :label="item" :value="key">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="客户等级" prop="level">
            <el-select v-if="levels" v-model="form_obj.level" placeholder="请选择" style="width:100%">
                <el-option v-for="(item, key) in levels" :key="item" :label="item" :value="key">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="成熟度">
            <el-select v-if="maturitys" v-model="form_obj.maturity" placeholder="请选择" style="width:100%">
                <el-option v-for="(item, key) in maturitys" :key="item" :label="item" :value="key">
                </el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="备注信息">
            <el-input v-model="form_obj.memo"></el-input>
        </el-form-item>

        <el-form-item label="班级数量" prop="class_num">
            <el-input v-model="form_obj.class_num"></el-input>
        </el-form-item>

        <el-form-item label="教师数量" prop="teacher_num">
            <el-input v-model="form_obj.teacher_num"></el-input>
        </el-form-item>

        <!-- <el-form-item label="访问权限">
            <el-radio v-model="form_obj.is_visit" label="0" >需要回访</el-radio>
            <el-radio v-model="form_obj.is_visit" label="1">不需要回访</el-radio>
        </el-form-item> -->

        <el-form-item v-if="$route.path == '/customers/update' || $route.path == '/customers/create'" label="业务员">
            <UserSelect1 v-model="form_obj.user_id" :uid="form_obj.username"  @change="UserHandleChange"></UserSelect1>
        </el-form-item>
        <el-form-item v-else label="业务员">
            <span>{{form_obj.username}}</span>
        </el-form-item>


        <el-form-item label="需要客服回访" prop="is_visit">
            <el-switch
                    active-color="#13ce66"
                    active-value="1"
                    inactive-value="0"
                    v-model="form_obj.is_visit"
            >
            </el-switch>
        </el-form-item>

        <el-form-item>
            <el-button type="primary" :loading="isDisable" @click="submitForm()">立即保存</el-button>
            <el-button @click="resetForm()">取消</el-button>
        </el-form-item>

    </el-form>
</template>

<script>
import CustomerService from "~/services/customer";
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
import UserSelect1 from "~/widgets/UserSelectCorp.vue";
import Config from "~/config/params";
import CommonService from "~/services/common";


export default {
    name: "subForm",
    components: {
        CustomerService,
        DistrictLinkage,
        UserSelect1,
        Config
    },

    data() {

        var validatePass = (rule,value,callback) => {
            if(!value) {
                callback(new Error('请输入班级数量'));
            } else if(isNaN(value)) {
                callback(new Error('班级数应为数值'));
            } else if(value < 0) {
                callback(new Error('班级数应大于0'));
            } else {
                callback();
            }
        };

        var validatePass1 = (rule,value,callback) => {
            if(!value) {
                callback(new Error('请输入教师数量'));
            } else if(isNaN(value)) {
                callback(new Error('教师数应为数值'));
            } else if(value < 0) {
                callback(new Error('教师数应大于0'));
            } else {
                callback();
            }
        };

        var validateName = (rule,value,callback) => {
            if(value.indexOf('测试') !=-1) {
                callback(new Error('客户名称禁止含有“测试”词语'));
            } else {
                callback();
            }
        };

        if (this.$route.path != '/customers/create') {
            return {
                form_obj: {
                    stages: [],
                    is_visit: '0',
                    origin:''
                },
                sources:[
                    {value:1,label:'系统客户'},
                    {value:2,label:'开发'},
                    {value:3,label:'运营'},
                    {value:4,label:'网上搜索'},
                    {value:5,label:'客户介绍'},
                    {value:6,label:'市场'},
                    {value:7,label:'项目招标'},
                    {value:8,label:'区域自拓'},
                ],
                types: {},
                maturitys: {},
                visits: {},
                levels: {},
                isDisable:false,
                config:[],
                // form: Model,
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入客户姓名",
                            trigger: "change"
                        },
                        {
                            validator: validateName,
                            trigger: 'change'
                        }
                    ],
                    origin: [{required: true, message: "请选择客户来源", trigger: "blur"}],
                    user_id: [{required: false, message: "请选择业务员", trigger: "blur"}],
                    level: [{required: true, message: "请选择客户等级", trigger: "blur"}],
                    memo: [{required: false, message: "请输入备注信息", trigger: "blur"}],

                },
              kehu_names: []
            };
        }else{
            return {
                form_obj: {
                    stages: [],
                    type: 0,
                    level: 0,
                    maturity: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    user_id: '',
                    is_visit: '0',
                    origin:''
                },
                sources:[
                    // {value:1,label:'系统客户'}, //新增客户时禁选 (系统客户,开发) 类型
                    // {value:2,label:'开发'},
                    {value:3,label:'运营'},
                    {value:4,label:'网上搜索'},
                    {value:5,label:'客户介绍'},
                    {value:6,label:'市场'},
                    {value:7,label:'项目招标'},
                    {value:8,label:'区域自拓'},
                ],
                isDisable:false,
                types: {},
                maturitys: {},
                levels: {},
                config:[],
                // form: Model,
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入客户姓名",
                            trigger: "change"
                        },
                        {
                            validator: validateName,
                            trigger: 'change'
                        }
                    ],
                    user_id: [{required: false, message: "请选择业务员", trigger: "blur"}],
                    origin: [{required: true, message: "请选择客户来源", trigger: "blur"}],
                    stages: [{required: true, message: "请选择学段", trigger: "change"}],
                    type: [{required: true, message: "请选择客户类型", trigger: "change"}],
                    province_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
                    city_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
                    district_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
                    level: [{required: true, message: "请选择客户等级", trigger: "change"}],
                    memo: [{required: false, message: "请输入备注信息", trigger: "blur"}],

                },
              kehu_names: []
            };
        }

    },

    props: {
        model: {},
        customerId: "",
        scenario: null,
        submiting: false
    },

    created() {

        this.isDisable = this.submiting;

        this.types = CustomerService.getTypes();
        this.levels = CustomerService.getLevels();
        this.maturitys = CustomerService.getMaturity();
        this.config = Config;
        this.form_obj = Object.assign({}, this.model);
        this.form_obj.maturity = this.form_obj.maturity.toString();
        this.form_obj.level = this.form_obj.level.toString();
        this.form_obj.type = this.form_obj.type.toString();
        this.form_obj.is_visit= this.form_obj.is_visit.toString();
    },

    watch: {
        submiting: function (value, oldValue) {
            this.isDisable = value;
        }
    },

    methods: {
        // 提交表单
        submitForm() {
            this.isDisable = true;
            this.$refs["form"].validate(valid => {
                this.isDisable = false;
                if (valid) {
                    // this.form_obj.username = undefined;
                    this.$emit("submit", this.form_obj, () => {
                        this.resetForm();
                    });
                } else {
                    this.isDisable = false;
                    return false;
                }
            });
        },

        // 重置表单
        resetForm() {
            this.$refs["form"].resetFields();
            this.form_obj.province_id = null;
            this.form_obj.city_id = null;
            this.form_obj.district_id = null;
            if (this.$route.path == '/customers/create') {
                this.$router.push({ path: "/customers/index"});
            } else {
                // 如果来自全部客户列表则还需回到全部客户列表
                if (this.$route.query['from'] && this.$route.query['from'] == 'index') {
                    this.$router.push({ path: "/customers/index" });
                } else if (this.$route.query['from'] && this.$route.query['from'] == 'public') {
                    this.$router.push({ path: "/customers/public" });
                } else {
                    this.$router.push({ path: "/customers/my-index" });
                }
            }
            //this.$router.push({ path: this.$route.query['referer']});
        },

        //业务员姓名远程搜索组件赋值
        UserHandleChange(value) {
            this.form_obj.user_id = value;
        },

        //地区联动 Cascader 级联选择器,切换事件,表单model赋值
        handleChange(value) {
            this.form_obj.province_id = Number(value[0]);
            this.form_obj.city_id = Number(value[1]);
            this.form_obj.district_id = Number(value[2]);
        },
      querySearchAsync(queryString) {
        let params = {
          keyword: queryString,
        };
        CommonService.getCustomersByEs(params).then(res => {
          this.kehu_names = res.data
        });
      },
      noShow(){
        this.kehu_names = []
      }
    },

};
</script>



// WEBPACK FOOTER //
// src/views/customer/form.vue